import axiosInstance from "./axiosInstance";

export const getAllBookings = async () => {
  try {
    const response = await axiosInstance.get("/booking", {
      headers: { authType: "PostLogin" } // requireLogin = true in backend
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch bookings");

  }
};

export const getBookingById = async (id) => {
  try {
    const response = await axiosInstance.get(`/bookingfetch/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to fetch booking");
  }
};

export const createBooking = async (formData) => {
  try {
    const response = await axiosInstance.post("/public/bookings", formData, {
      headers: {
        "Content-Type": "application/json",
        authType: "PreLogin", // ✅ because requireLogin = false in backend

      },
    });
    return response.data;
  } catch (error) {

    throw new Error(error.response?.data?.message || "Failed to create booking");
  }
};




export const deleteBooking = async (id) => {
  try {
    const response = await axiosInstance.delete(`/bookingdel/${id}`, {
      headers: { authType: "PostLogin" },
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.token || "Failed to delete booking");
  }
};

